import { createBrandedType } from "./branded";

export const ObsidianUserId = createBrandedType<string, "obsidianUserId">();

export const ObsidianJavaAccountId = createBrandedType<
  string,
  "obsidianJavaAccountId"
>();

export const BaseWorldId = createBrandedType<string, "baseWorldId">();

export const BaseWorldImageId = createBrandedType<string, "baseWorldImageId">();

export const WorldId = createBrandedType<string, "worldId">();

export const WorldSnapshotId = createBrandedType<string, "worldSnapshotId">();

export const KopiaSnapshotId = createBrandedType<string, "kopiaSnapshotId">();

export const WorldSnapshotEventId = createBrandedType<
  string,
  "worldSnapshotEventId"
>();

export const GameServerSessionId = createBrandedType<
  string,
  "gameServerSessionId"
>();

export const GameServerSessionEventId = createBrandedType<
  string,
  "gameServerSessionEventId"
>();

export const GameServerNodeId = createBrandedType<string, "gameServerNodeId">();

export const AssetServerNodeId = createBrandedType<
  string,
  "assetServerNodeId"
>();

export const JavaEditionProfileId = createBrandedType<
  string,
  "javaEditionProfileId"
>();

export const PlayerUsername = createBrandedType<string, "playerUsername">();

export const MinecraftJavaAccountId = createBrandedType<
  string,
  "minecraftJavaAccountId"
>();
